import { TComment } from "../comment/comment.types";
// TODO: move to a shared reusable https://wikifolio.atlassian.net/browse/WIKI-33310
export const removeDuplicates = (comments: readonly TComment[]) => {
    const seen = new Set();

    return comments.filter(comment => {
        const duplicate = seen.has(comment.commentId);
        seen.add(comment.commentId);
        return !duplicate;
    });
};
